/** @jsxImportSource @emotion/react */

import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContext } from "../../context/login-context";

// import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { IconButton } from "@mui/material";

// import useFarms from "../../hooks/use-farms.js";
import useStrategicAccounts from "../../hooks/use-strategic-accounts.js";
// import useRebates from "../../hooks/use-rebates.js";

import {
	CustomToolbar,
	DataGrid,
	Icon,
	Submenu,
} from "../../components/index.js";

// import ModalAccount from "./modals/modal-account.js";
// import ModalAccountRemove from "./modals/modal-account-remove.js";

// import css from "./accounts.module.css";
import useDealers from "../../hooks/use-dealers.js";
import ModalAccount from "../accounts/modals/modal-account.js";
import ModalDealer from "./modal-dealer.js";

dayjs.extend(utc);

const Dealers = (props) => {
	const { runProtected, state: userData } = useContext(LoginContext);
	const navigate = useNavigate();

	const { dealers, refetchDealers } = useDealers();

	const [rows, setRows] = useState([]);
	const [showAccountModal, setShowAccountModal] = useState(false);

	useEffect(() => {
		setRows(dealers);
	}, [dealers]);

	const handleAddDealer = (id) => {
		setShowAccountModal(true);
	};

	const modalClose = () => {
		setShowAccountModal(false);
		refetchDealers();
	};

	const columns = [
		{
			field: "name",
			headerName: "Dealer Name",
			type: "text",
		},
		{
			field: "farm",
			headerName: "Farms",
			type: "text",
			renderCell: (params) => {
				return (
					<div >
						{params?.row?.farms?.map((farm, index) => (
							<div key={farm.id}>
								{farm.name}
								{index < params?.row?.farms.length - 1
									? ", "
									: ""}
							</div>
						))}
					</div>
					
				);
			},
		},
		{
			field: "users",
			headerName: "Users",
			type: "text",
			renderCell: (params) => {
				return (
					<div >
						{params?.row?.users?.map((user, index) => (
							<div key={user.id}>
								{user.first_name} {user.last_name}
								{index < params?.row?.users.length - 1
									? ", "
									: ""}
							</div>
						))}
					</div>
					
				);
			},
		},
		{
			field: "action",
			headerName: "",
			sortable: false,
			align: "right",
			renderCell: (params) => {
				return (
					<>
						<IconButton>
							<Icon icon="ChevronRight" />
						</IconButton>
					</>
				);
			},
		},
	];

	const modals = (
		<>
			<ModalDealer
				open={showAccountModal}
				onClose={modalClose}
				// account={{account_type: "DEALER"}}
			/>
		</>
	);

	const table = (
		<DataGrid
			toolbarTitle="Dealers"
			toolbarBtnTitle="+ Add new dealer"
			toolbarOnClick={() => handleAddDealer()}
			toolbarBtnVisible={userData?.isValmontUser}
			rows={rows}
			columns={columns}
			onRowClick={(params) => {
				navigate(`/dealer/${encodeURIComponent(params.row.name)}`);
			}}
			sx={{
				"& .MuiDataGrid-columnSeparator": {
					display: "none",
				},
			}}
		/>
	);

	return (
		<>
			{table}
			{modals}
		</>
	);
};

export default Dealers;
